import { Injectable, WritableSignal, signal, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  private _translateService = inject(TranslateService);

  public selectedLanguage: WritableSignal<string> = signal('es');

  setTranslateService(lang: string): void {
    this._translateService.setDefaultLang(lang);
    this._translateService.use(lang);
    this.selectedLanguage.set(lang);
  }
}
